module.exports = __webpack_public_path__ + "static/media/easybutton.91f39272.png";